module.exports = __webpack_public_path__ + "img/loading_error.95a5d41a.svg";